<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="createEpi">
      <b-form
        class="mt-2"
        @submit.prevent="handleSubmit"
        @keydown.enter="handleSubmit"
      >
        <b-row>
          <b-col cols="12">
            <h4 class="mb-2">
              {{ $t("Añadiractivos") }}
            </h4>
          </b-col>
          <!--   <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('Nombre')"
              rules="required"
            >
              <b-form-group :label="$t('Nombre')" label-for="epi-name">
                <b-form-input
                  v-model="name"
                  name="name"
                  :placeholder="$t('Nombre')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col> -->
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('NumeroSerie')"
            >
              <b-form-group
                :label="$t('NumeroSerie')"
                label-for="epi-serial_number"
              >
                <b-form-input
                  v-model="serial_number"
                  name="serial_number"
                  :placeholder="$t('NumeroSerie')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <b-form-group
                :label="$t('NumeroAlbaran')"
                label-for="epi-pedido_num_id"
            >
              <b-form-input
                  v-model="pedido_num_id"
                  name="pedido_num_id"
                  :placeholder="$t('NumeroAlbaran')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" v-if="currentCompany.id === 3">
            <validation-provider
                #default="{ errors }"
                :name="$t('Coste')"
                rules=""
            >
              <b-form-group
                  :label="$t('Coste')"
                  label-for="equipos-coste"
              >
                <b-input-group append="€">
                  <b-form-input
                      v-model="coste"
                      name="equipos-coste"
                      type="number"
                      :placeholder="$t('Coste')"
                  />
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('Localizacion')"
              rules="required"
            >
              <b-form-group
                :label="$t('Localizacion')"
                label-for="epi-location"
              >
                <v-select
                  v-model="location"
                  label="name"
                  :filterable="false"
                  :searchable="false"
                  :options="selectLocations"
                  :placeholder="$t('Localizacion')"
                >
                  <template
                    slot="option"
                    slot-scope="option"
                  >
                    {{ option.name }}
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="option"
                  >
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <!--     <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('Estado')"
              rules="required"
            >
              <b-form-group :label="$t('Estado')" label-for="epi-status">
                <v-select
                  label="alias"
                  :filterable="false"
                  :searchable="false"
                  :options="selectStatus"
                  :placeholder="$t('Estado')"
                  v-model="status"
                >
                  <template slot="option" slot-scope="option">
                    {{ $t("status.epis." + option.alias) }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    {{ $t("status.epis." + option.alias) }}
                  </template>
                </v-select>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>-->

          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('Producto')"
              rules="required"
            >
              <b-form-group
                :label="$t('Producto')"
                label-for="epi-product"
              >
                <SelectProducts v-model="product" type="epi" />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('FechaCompra')"
              rules="required"
            >
              <b-form-group
                :label="$t('FechaCompra')"
                label-for="epi-purchase_date"
              >
                <flat-pickr
                  v-model="purchase_date"
                  name="purchase_date"
                  class="form-control"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <!--   <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('VidaUtilMeses')"
              rules="required"
            >
              <b-form-group
                :label="$t('VidaUtilMeses')"
                label-for="epi-vida-util"
              >
                <b-form-input
                  v-model="vida_util"
                  name="vida-util"
                  type="number"
                  :placeholder="$t('VidaUtilMeses')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('FrecuenciaRevisiones')"
              rules="required"
            >
              <b-form-group
                :label="$t('FrecuenciaRevisiones')"
                label-for="epi-frecuencia-revisiones"
              >
                <b-form-input
                  v-model="frecuencia_revisiones"
                  name="frecuencia-revisiones"
                  type="number"
                  :placeholder="$t('FrecuenciaRevisiones')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>-->
          <!--    <b-col sm="6">
            <b-form-group
              :label="$t('UltimaRevision')"
              label-for="epi-last_review"
            >
              <flat-pickr
                v-model="last_review"
                name="last_review"
                class="form-control"
              />
            </b-form-group>
          </b-col> -->
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('ProximaRevision')"
              :rules="prox_revision_required"
            >
              <b-form-group
                :label="$t('ProximaRevision')"
                label-for="epi-next_review"
              >
                <flat-pickr
                  v-model="next_review"
                  name="next_review"
                  class="form-control"
                  :disabled="isDisabled"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('NumeroDeEquipos')"
              rules="required"
            >
              <b-form-group
                :label="$t('NumeroDeEquipos')"
                label-for="num-equipos-revisiones"
              >
                <b-form-input
                  v-model="num_equipos"
                  name="numero-equipos"
                  type="number"
                  :placeholder="$t('NumeroDeEquipos')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="12">
            <!--          <validation-provider
              #default="{ errors }"
              :name="$t('Descripcion')"
              rules="required"
            > -->
            <b-form-group
              :label="$t('Descripcion')"
              label-for="epi-description"
            >
              <quill-editor v-model="description" />
            </b-form-group>
            <!--   <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-col>

          <!--    <b-col sm="12">
            <b-form-group :label="$t('Documentos')" label-for="epi-documents">
              <ImageDropzone ref="documents" :files="files" maxFiles="10" />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group :label="$t('Revision')" label-for="epi-review">
              <ImageDropzone ref="review" :files="review" maxFiles="1" />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group :label="$t('Entrega')" label-for="epi-delivery">
              <ImageDropzone ref="delivery" :files="delivery" maxFiles="1" />
            </b-form-group>
          </b-col> -->
          <b-col cols="12 text-right">
            <b-button
              type="submit"
              variant="primary"
              class="mt-2 mr-1"
            >
              {{ $t("Enviar") }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BPagination, BInputGroup,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { FlatPickrToTimestamp } from '@/libs/helpers'
import vSelect from 'vue-select'
import moment from 'moment'
import SelectProducts from '@/components/selectProducts/SelectProducts.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    quillEditor,
    vSelect,
    BPagination,
    SelectProducts,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      currentPage: 1,
      pageLength: 10,
      name: '',
      serial_number: '',
      location: '',
      pedido_num_id: '',
      description: '',
      last_review: '',
      purchase_date: moment(new Date()).format('DD/MM/YYYY'),
      frecuencia_revisiones: 12,
      next_review: '',
      product: '',
      user: '',
      files: [],
      review: [],
      delivery: [],
      status: '',
      num_equipos: 1,
      required,
      email,
      prox_revision_required: '',
      isDisabled: false,
      search: '',
      coste: '',
    }
  },
  computed: {
    ...mapGetters({
      totalItems: 'products/getTotalItems',
      localeDatePicker: 'languages/getLocaleDatePicker',
      // selectStatus: 'epis/getSelectStatus',
      currentClient: 'clients/getCurrentClient',
      currentCompany: 'companies/getCurrentCompany',
      selectDepartments: 'departments/getSelectDepartments',
      selectLocations: 'locations/getSelectLocations',
    }),
  },
  methods: {
    ...mapActions({
      create: 'epis/create',
      // getSelectStatus: 'epis/selectStatus',
      getSelectDepartments: 'departments/selectDepartments',
      getSelectLocations: 'locations/getSelectLocations',
    }),
    changeProduct(value) {
      this.product = value
    },
    handleSubmit() {
      this.$refs.createEpi.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.create({ epi: formData })
          }
        }
      })
    },
    addMonths(numOfMonths, date = new Date()) {
      date.setMonth(date.getMonth() + numOfMonths)

      return date
    },
    isValidDate(date) {
      return (
        date
        && Object.prototype.toString.call(date) === '[object Date]'
        && !isNaN(date)
      )
    },
    createFormData() {
      /*   let data = this.$refs.documents.getFormData("documents"); */
      const data = new FormData()
      if (this.last_review) {
        data.append('last_review_date', FlatPickrToTimestamp(this.last_review))
      }

      if (this.next_review) {
        data.append('next_review_date', FlatPickrToTimestamp(this.next_review))
      } else {
        data.append('next_review_date', null)
      }
      if (this.purchase_date) {
        data.append('purchase_date',FlatPickrToTimestamp(this.purchase_date))
      } else {
        data.append('purchase_date', null)
      }

      data.append('status_epi_id', 1)
      if (this.location) {
        data.append('location_id', this.location.id)
        data.append('origin_location_id', this.location.id)
      }
      data.append('client_id', this.currentClient.id)
      data.append('serial_number', this.serial_number)
      data.append('description', this.description)
      data.append('product_id', this.product.id)
      data.append('quantity', this.num_equipos)
      data.append('pedido_num_id', this.pedido_num_id)
      data.append('coste', this.coste)

      return data
    },
  },

  watch: {
    purchase_date(val) {
      if (!this.isDisabled) {
        const date = `${val.split('/')[1]}/${val.split('/')[0]}/${val.split('/')[2]}`

        this.next_review = moment(String(new Date(date)))
          .add(this.frecuencia_revisiones, 'M')
          .format('DD/MM/YYYY')
      }
    },
    frecuencia_revisiones(val) {
      const purchase = this.purchase_date
      const date = `${purchase.split('/')[1]}/${purchase.split('/')[0]}/${purchase.split('/')[2]}`

      this.next_review = moment(String(new Date(date)))
        .add(val, 'M')
        .format('DD/MM/YYYY')
    },
    product() {
      if (this.product) {
        if (this.product.type_review) {
          this.isDisabled = false
          if (this.product.type_review.obligatoria === 1 && this.product.type_review.periodica === 0) {
            this.prox_revision_required = 'required'
          } else if (this.product.type_review.obligatoria === 1 && this.product.type_review.periodica === 1) {
            if (this.purchase_date) {
              const ahora = new Date()
              this.next_review = ahora.setMonth(
                ahora.getMonth() + this.product.type_review.tiempoMeses,
              )
              console.log(this.product.type_review.tiempoMeses)
              this.frecuencia_revisiones = this.product.type_review.tiempoMeses
            }
          } else if (this.product.type_review.obligatoria === 0) {
            this.isDisabled = true
            this.next_review = null
          }
        }
      }
    },
  },
  async created() {
    const ahora = new Date()
    this.next_review = moment(ahora.setMonth(
      ahora.getMonth() + this.frecuencia_revisiones,
    )).format('DD/MM/YYYY'),
    // await this.getSelectStatus()
    await this.getSelectDepartments({ clients: [this.currentClient] })
    await this.getSelectLocations({ clients: [this.currentClient.id] })
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.form-control:disabled{
  background-color: #f8f8f8 !important;
}
</style>
